
const aeRegionSelector = state =>  state.project.projectAeRegions.aeRegion
const aeRegionSelectionSelector = state =>  state.project.projectAeRegions.aeRegionSelection

export {
  aeRegionSelector,
  aeRegionSelectionSelector,
}
